import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "../../../../store/hooks";

const CountryCode = ({ code }) => {
  const { t } = useTranslation();
  const taxonomy = useSelector((s) => s.taxonomy);
  return <span>{t(taxonomy.Country.byId[code]?.code)}</span>;
};

export default CountryCode;
